<template>
  <div>
    <Form ref="searchForm" :model="searchForm" :label-width="110">
      <div v-if="showMoreCondition" class="condition-container">
        <Row>
          <Col :xs="24" :sm="24" :lg="8">
            <FormItem :label-width="90" style="margin-bottom: 10px;" :label="$t('label.project.date')">
              <DatePicker
                transfer
                transfer-class-name="pbr"
                :value="searchForm.pdate"
                :options="dateOptions"
                @on-change="(val) => { searchForm.pdate = val }"
                format="yyyy-MM-dd"
                type="daterange"
                :editable="false"
                clearable
                placement="bottom-start"
                :placeholder="$t('label.date')"
                style="width: 100%;">
              </DatePicker>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :lg="8">
            <FormItem :label-width="90" style="margin-bottom: 10px;" :label="$t('label.information.multilateral.org')">
              <Select
                v-model="searchForm.orgs"
                :max-tag-count="0"
                :max-tag-placeholder="maxTagPlaceholder"
                clearable
                filterable
                multiple
                transfer
                transfer-class-name="pbr"
                :placeholder="$t('placeholders.information.selectOrSearch')"
                @on-query-change="onOrgQueryChange"
                @on-open-change="onOrgOpenChange">
                <Icon
                  v-if="searchForm.orgs && searchForm.orgs.length"
                  type="md-close-circle"
                  slot="prefix"
                  style="display: flex;"
                  @click.stop="searchForm.orgs = []"/>
                <Option v-for="item in filteredOrgOptions" :key="item.code" :value="JSON.stringify(item)">
                  {{ optionLabel(item) }}
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :lg="8">
            <FormItem :label-width="90" style="margin-bottom: 10px;" :label="$t('label.information.multilateral.region')">
              <Select
                v-model="searchForm.regions"
                :max-tag-count="0"
                :max-tag-placeholder="maxTagPlaceholder"
                clearable
                filterable
                multiple
                transfer
                transfer-class-name="pbr"
                :placeholder="$t('placeholders.information.selectOrSearch')">
                <Icon
                  v-if="searchForm.regions && searchForm.regions.length"
                  type="md-close-circle"
                  slot="prefix"
                  style="display: flex;"
                  @click.stop="searchForm.regions = []"/>
                <Option v-for="item in regionOptions" :key="item.code" :value="JSON.stringify(item)">
                  {{ optionLabel(item) }}
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :lg="8">
            <FormItem :label-width="90" style="margin-bottom: 10px;" :label="$t('label.information.multilateral.infoType')">
              <Select
                v-model="searchForm.tags"
                :max-tag-count="0"
                :max-tag-placeholder="maxTagPlaceholder"
                clearable
                filterable
                multiple
                transfer
                transfer-class-name="pbr"
                :placeholder="$t('placeholders.pleaseSelect')">
                <Icon
                  v-if="searchForm.tags && searchForm.tags.length"
                  type="md-close-circle"
                  slot="prefix"
                  style="display: flex;"
                  @click.stop="searchForm.tags = []"/>
                <Option v-for="item in tagOptions" :key="item.code" :value="JSON.stringify(item)">
                  {{ optionLabel(item) }}
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :lg="8">
            <FormItem :label-width="90" style="margin-bottom: 10px;" :label="$t('label.information.multilateral.infoCategory')">
              <Select
                v-model="searchForm.categories"
                :max-tag-count="0"
                :max-tag-placeholder="maxTagPlaceholder"
                clearable
                filterable
                multiple
                transfer
                transfer-class-name="pbr"
                :placeholder="$t('placeholders.pleaseSelect')">
                <Icon
                  v-if="searchForm.categories && searchForm.categories.length"
                  type="md-close-circle"
                  slot="prefix"
                  style="display: flex;"
                  @click.stop="searchForm.categories = []"/>
                <Option v-for="item in categoryOptions" :key="item.code" :value="JSON.stringify(item)">
                  {{ optionLabel(item) }}
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :lg="8">
            <FormItem :label-width="90" style="margin-bottom: 10px;" :label="$t('label.source')">
              <Input
                v-model="searchForm.sourceType"
                clearable
                :placeholder="$t('placeholders.information.source')"/>
            </FormItem>
          </Col>
        </Row>
      </div>

      <div style="margin-bottom: 10px;">
        <AutoComplete
          clearable
          v-model="searchForm.keywords"
          transfer
          :placeholder="$t('placeholders.information.keywords')"
          class="auto-complete">
        </AutoComplete>
        <iSwitch :class="{'switch-en': isEN}" size="large" true-value="1" false-value="0" v-model="searchForm.searchModel">
          <span slot="open" :class="{'ivu-switch-inner-en': isEN}">{{ $t('buttons.switch.accurate') }}</span>
          <span slot="close">{{ $t('buttons.switch.fuzzy') }}</span>
        </iSwitch>
        <Button type="primary" @click="okBtn">{{ $t('buttons.search') }}</Button>
        <Button @click="reset">{{ $t('buttons.reset') }}</Button>
        <el-link
          type="text"
          :underline="false"
          @click="openHistory"
          style="color: #008bce;cursor: pointer;"
          class="padding5"
          v-html="$t('buttons.searchHistory')"></el-link>
        <el-link
          v-if="showMoreCondition"
          class="padding5"
          type="default"
          :underline="false"
          @click="showMoreCondition = false"
          v-html="$t('buttons.advanceRetrieval', { type: 'up' })"></el-link>
        <el-link
          v-else
          class="padding5"
          type="default"
          :underline="false"
          @click="showMoreCondition = true"
          v-html="$t('buttons.advanceRetrieval', { type: 'down' })"></el-link>
      </div>

      <div v-if="showMoreCondition" v-show="Object.keys(myCondition).length > 0" class="my-condition-box" style="padding-right: 50px;">
        <label style="float:left;line-height: 27px;">{{ $t('label.project.searchCondition') }}：</label>
        <div style="margin-left: 110px;">
          <p v-for="(item, key) in myCondition" :key="key">
            <label>{{ item.tag }}：</label>
            <template v-if="key === 'pdate'">
              <span class="condition-text">{{ item.list.join(' - ') }}</span>
            </template>
            <template v-else-if="key === 'sourceType'">
              <span class="condition-text">
                <i class="el-icon-error condition-item-close" @click="clearCondition('sourceType')"></i>
                {{ item.text }}
              </span>
            </template>
            <template v-else>
              <span v-for="(obj, i) in item.list" :key="i">
                <span class="condition-text">
                  <i class="el-icon-error condition-item-close" @click="item.list.splice(i, 1)"></i>
                  {{ parseOptionTitle(obj) }}
                </span>
                {{ i === item.list.length - 1 ? '' : '，' }}
              </span>
            </template>
            <i class="el-icon-circle-close condition-close" @click="clearCondition(key)"></i>
          </p>
        </div>
      </div>
    </Form>

    <div class="table-top-box">
      <span class="fl">
        <Checkbox
          style="margin:0 13px 0 13px;"
          :indeterminate="indeterminate"
          :value="checkAll"
          @on-change="handleCheckAll"></Checkbox>
        <Divider type="vertical"/>
        <el-link @click="sortByTime">
          <i :class="sortByTimeIcon" style="font-size: 14px;font-weight: 800"></i>
          {{ $t('buttons.information.time') }}
        </el-link>
      </span>
      <span class="fr right" @click="exportList"><span class="excel-png"></span>{{ $t('buttons.export') }}</span>
    </div>

    <div class="newInfo-list">
      <Table
        ref="infoTable"
        :show-header="false"
        :columns="columns"
        :data="tableData"
        :loading="tableLoading"
        @on-selection-change="tableSelectionChange">
        <template slot="fav" slot-scope="{ row }">
          <Icon
            :type="row.favStatus ? 'md-star' : 'md-star-outline'"
            color="#008acd"
            style="font-size: 20px;"
            @click="editFavorite(row)"
            class="pointer"/>
        </template>
        <template slot-scope="{ row }" slot="title">
          <div class="newInfo-list-item">
            <div class="item-detail">
              <p class="item-detail-title" @click="gotoDetail(row)" v-html="row.title"></p>
              <p class="item-detail-tag-box">
                <el-tag
                  v-for="(tag, idx) in getRowTags(row)"
                  :key="idx + '-' + tag"
                  effect="plain"
                  size="small"
                  class="md-info-tag"
                  @click="tagClick(tag, row)">
                  {{ tag }}
                </el-tag>
                <span style="margin: 0 15px;color: #808c9a;font-size: 12px;">|</span>
                <template v-if="row.sourceType">
                  <span style="color: #808c9a;font-size: 12px;">{{ row.sourceType }}</span>
                  <Divider type="vertical"/>
                </template>
                <span style="color: #808c9a;font-size: 12px;">{{ row.newsTime || row.articleDate | format(that) }}</span>
              </p>
            </div>
          </div>
        </template>
      </Table>
    </div>

    <el-pagination
      :current-page="currentPage"
      :page-size="pageSize"
      :page-sizes="[8, 10, 20, 50, 100]"
      :pager-count="5"
      :total="totalElements"
      layout="total, sizes, prev, pager, next, jumper"
      style="margin-top: 10px"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>

    <el-dialog
      :modal="false"
      :visible.sync="historyModal"
      append-to-body
      custom-class="pbr"
      :title="$t('table.history.title')"
      width="600px">
      <div style="text-align: right;margin-bottom: 10px;">
        <Button @click="delAllHistory" type="primary">{{ $t('buttons.delAll') }}</Button>
      </div>
      <Table
        :columns="historyColumns"
        :data="historyTableData"
        border
        @on-row-click="historyRowDbClick"
        class="pbr-info-history-table">
        <template slot="top" slot-scope="{ row }">
          <div style="cursor:pointer;" @click.stop="toTopHistory(row)">
            <Icon :class="favIconClass(row)" style="font-size: 20px;" type="md-arrow-round-up"/>
          </div>
        </template>
        <template slot="operate" slot-scope="{ row }">
          <Icon style="font-size: 20px;cursor:pointer;" type="md-trash" @click.stop="delHistory(row)"/>
        </template>
      </Table>
    </el-dialog>
  </div>
</template>

<script>
import { contentType, exportFilePost } from '../apis/common'
import {
  MD_DICT,
  MD_TAG_OPTIONS,
  MD_CATEGORY_OPTIONS,
  MD_REGION_OPTIONS,
  MD_ORG_OPTIONS,
  MD_FALLBACK,
  joinCodes,
  optionLabel as getOptionLabel,
  normalizeRegionStatistic,
  mapDictItems
} from './multilateralOptions'

export default {
  name: 'MultilateralDynamics',
  props: {
    hotWord: {
      type: String,
      default: ''
    },
    regionFilter: {
      type: Object,
      default: null
    }
  },
  data () {
    const self = this
    return {
      that: this,
      tableLoading: false,
      showMoreCondition: false,
      searchForm: {
        keywords: '',
        orgs: [],
        regions: [],
        tags: [],
        categories: [],
        sourceType: '',
        pdate: [],
        searchModel: '0',
        orderby: '',
        orderkey: ''
      },
      myCondition: {},
      tagOptions: MD_TAG_OPTIONS.slice(),
      categoryOptions: MD_CATEGORY_OPTIONS.slice(),
      regionOptions: MD_REGION_OPTIONS.slice(),
      orgOptions: MD_ORG_OPTIONS.slice(),
      orgQuery: '',
      isOrgOpen: false,
      dateOptions: {
        shortcuts: [
          {
            text: this.$t('datePicker.threeMonths'),
            value () {
              const end = self.$moment().format('yyyy-MM-DD')
              const start = self.$moment().subtract(3, 'month').format('yyyy-MM-DD')
              return [start, end]
            }
          },
          {
            text: this.$t('datePicker.oneYear'),
            value () {
              const end = self.$moment().format('yyyy-MM-DD')
              const start = self.$moment().subtract(1, 'year').format('yyyy-MM-DD')
              return [start, end]
            }
          },
          {
            text: this.$t('datePicker.threeYears'),
            value () {
              const end = self.$moment().format('yyyy-MM-DD')
              const start = self.$moment().subtract(3, 'year').format('yyyy-MM-DD')
              return [start, end]
            }
          }
        ]
      },
      tableData: [],
      tableSelection: [],
      pageSize: 8,
      currentPage: 1,
      totalPages: 0,
      totalElements: 0,
      columns: [
        { type: 'selection', width: 40, align: 'center' },
        { title: ' ', width: 30, slot: 'fav', align: 'center' },
        { title: this.$t('table.project.main.title'), slot: 'title' }
      ],
      indeterminate: false,
      checkAll: false,
      isSortByTime: null,
      isSortByTimeDesc: false,
      historyModal: false,
      historyColumns: [
        {
          title: this.$t('table.project.history.columns.top'),
          width: 50,
          slot: 'top',
          align: 'center'
        },
        {
          // 与会展/项目 ghconditions 一致：展示字段为 name；兼容资讯模块 searchCondition
          title: this.$t('table.project.history.columns.title'),
          key: 'name',
          render: (h, params) => {
            const row = params.row || {}
            let text = row.name || row.searchCondition || ''
            if (!text && row.conditions) {
              text = this.formatHistoryConditionText(row.conditions)
            }
            return h('span', String(text || '').replace(/,{2,}/g, ''))
          }
        },
        {
          title: this.$t('table.project.history.columns.delete'),
          width: 80,
          slot: 'operate',
          align: 'center'
        }
      ],
      historyTableData: []
    }
  },
  computed: {
    isEN () {
      return localStorage.getItem('locale') === 'en'
    },
    lang () {
      return this.isEN ? 'en' : 'cn'
    },
    sortByTimeIcon () {
      if (this.isSortByTime) {
        return this.isSortByTimeDesc ? 'el-icon-sort-down' : 'el-icon-sort-up'
      }
      return 'el-icon-sort el-icon--left'
    },
    filteredOrgOptions () {
      const query = (this.orgQuery || '').toLowerCase()
      if (!query) return this.orgOptions
      return this.orgOptions.filter(item => {
        const label = (this.optionLabel(item) || '').toLowerCase()
        return label.indexOf(query) > -1
      })
    }
  },
  mounted () {
    this.fetchHotSpot()
    this.loadDictOptions().finally(() => {
      this.search()
    })
  },
  methods: {
    loadDictOptions () {
      const jobs = [
        { dict: MD_DICT.tag, key: 'tagOptions' },
        { dict: MD_DICT.category, key: 'categoryOptions' },
        { dict: MD_DICT.region, key: 'regionOptions' },
        { dict: MD_DICT.org, key: 'orgOptions' }
      ]
      return Promise.all(jobs.map(({ dict, key }) => {
        return this.$pbrApis.fetchMultilateralDictItems(dict).then(res => {
          const list = mapDictItems((res && res.result) || [])
          if (list.length) {
            this[key] = list
          } else if (MD_FALLBACK[dict]) {
            this[key] = MD_FALLBACK[dict].slice()
          }
        }).catch(() => {
          if (MD_FALLBACK[dict]) {
            this[key] = MD_FALLBACK[dict].slice()
          }
        })
      }))
    },
    optionLabel (item) {
      return getOptionLabel(item, this.isEN)
    },
    parseOptionTitle (raw) {
      try {
        const obj = typeof raw === 'string' ? JSON.parse(raw) : raw
        return this.optionLabel(obj) || obj.title || obj.code
      } catch (e) {
        return raw
      }
    },
    maxTagPlaceholder (num) {
      return '... ' + num
    },
    clearCondition (key) {
      if (key === 'pdate') {
        this.searchForm.pdate = []
      } else if (key === 'sourceType') {
        this.searchForm.sourceType = ''
      } else {
        this.searchForm[key] = []
      }
    },
    onOrgQueryChange (query) {
      if (!this.isOrgOpen) return
      // 选择 option 时组件会把 query 置空，已有选中项时忽略这次清空，保持当前检索列表
      if (query === '' && this.searchForm.orgs && this.searchForm.orgs.length > 0) {
        return
      }
      this.orgQuery = query
    },
    onOrgOpenChange (open) {
      this.isOrgOpen = open
      if (!open) {
        this.orgQuery = ''
      }
    },
    getSearchBody () {
      const pdate = this.searchForm.pdate || []
      return {
        lang: this.lang,
        from: this.lang,
        searchkey: this.searchForm.keywords ? this.searchForm.keywords.trim() : '',
        title: this.searchForm.keywords ? this.searchForm.keywords.trim() : '',
        searchModel: this.searchForm.searchModel,
        tagCode: joinCodes(this.searchForm.tags),
        categoryCode: joinCodes(this.searchForm.categories),
        regionCode: joinCodes(this.searchForm.regions),
        orgCodes: joinCodes(this.searchForm.orgs),
        sourceType: this.searchForm.sourceType ? this.searchForm.sourceType.trim() : '',
        newsTimeStart: pdate[0] ? `${pdate[0]} 00:00:00` : '',
        newsTimeEnd: pdate[1] ? `${pdate[1]} 23:59:59` : '',
        orderby: this.searchForm.orderby || '',
        orderkey: this.searchForm.orderkey || ''
      }
    },
    okBtn () {
      this.currentPage = 1
      this.search()
    },
    search () {
      if (this.searchForm.keywords && this.searchForm.keywords.length > 100) {
        return
      }
      this.tableLoading = true
      const body = this.getSearchBody()
      const query = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      }
      this.$pbrApis.searchMultilateralDynamics(body, query).then(res => {
        this.tableLoading = false
        if (res && (res.success || res.code === 200)) {
          const result = res.result || {}
          const list = result.content || result.records || result.list || []
          this.tableData = list
          this.totalPages = result.totalPages || Math.ceil((result.total || result.totalElements || 0) / this.pageSize) || 0
          this.totalElements = result.totalElements != null ? result.totalElements : (result.total || list.length)
          this.$pbrApis.saveMultilateralSearchHistory(body).catch(() => {})
        }
      }).catch(() => {
        this.tableLoading = false
      })
      this.fetchRegionStatistic(body)
    },
    fetchRegionStatistic (body) {
      this.$pbrApis.fetchMultilateralRegionStatistic(body || this.getSearchBody()).then(res => {
        if (res && (res.success || res.code === 200)) {
          const data = normalizeRegionStatistic(res.result, this.isEN, this.regionOptions)
          this.$emit('region-stat', data)
        }
      }).catch(() => {})
    },
    fetchHotSpot () {
      this.$pbrApis.searchMultilateralDynamics({
        lang: this.lang,
        from: this.lang,
        tagCode: '',
        categoryCode: 'rule',
        orderby: 'desc',
        orderkey: 'newsTime'
      }, { pageNo: 1, pageSize: 15 }).then(res => {
        if (res && (res.success || res.code === 200)) {
          const result = res.result || {}
          const list = result.content || result.records || result.list || []
          this.$emit('hotspot', list.map(item => ({
            id: item.id,
            title: item.title,
            time: item.newsTime || item.articleDate || item.time
          })))
        }
      }).catch(() => {})
    },
    reset () {
      this.searchForm = {
        keywords: '',
        orgs: [],
        regions: [],
        tags: [],
        categories: [],
        sourceType: '',
        pdate: [],
        searchModel: '0',
        orderby: '',
        orderkey: ''
      }
      this.isSortByTime = null
      this.isSortByTimeDesc = false
      this.currentPage = 1
      this.search()
    },
    sortByTime () {
      this.isSortByTime = true
      this.isSortByTimeDesc = !this.isSortByTimeDesc
      this.searchForm.orderkey = 'newsTime'
      this.searchForm.orderby = this.isSortByTimeDesc ? 'desc' : 'asc'
      this.search()
    },
    handleCheckAll (flag) {
      this.checkAll = flag
      if (flag) {
        this.$refs.infoTable.selectAll(true)
      } else {
        this.$refs.infoTable.selectAll(false)
        this.indeterminate = false
      }
    },
    tableSelectionChange (selection) {
      this.tableSelection = selection
      if (selection.length === this.pageSize) {
        this.indeterminate = false
        this.checkAll = true
      } else {
        this.indeterminate = !!selection.length
        this.checkAll = false
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.search()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.search()
    },
    getRowTags (row) {
      const tags = []
      const pushNames = (value) => {
        if (value == null || value === '') return
        String(value).split(',').forEach(name => {
          const text = name.trim()
          if (text) tags.push(text)
        })
      }
      pushNames(row.tagName)
      pushNames(row.categoryName)
      pushNames(row.regionName)
      pushNames(row.orgNames)
      return tags
    },
    tagClick (tag) {
      this.showMoreCondition = true
      const tryMatch = (options, field) => {
        const found = options.find(o => this.optionLabel(o) === tag || o.title === tag || o.titleEn === tag || o.code === tag)
        if (found) {
          const val = JSON.stringify(found)
          if (!this.searchForm[field].includes(val)) {
            this.searchForm[field] = [val]
          }
          this.okBtn()
          return true
        }
        return false
      }
      if (tryMatch(this.tagOptions, 'tags')) return
      if (tryMatch(this.categoryOptions, 'categories')) return
      if (tryMatch(this.regionOptions, 'regions')) return
      tryMatch(this.orgOptions, 'orgs')
    },
    applyRegionFilter (region) {
      if (!region) return
      const opt = this.regionOptions.find(r => r.code === region.code || r.title === region.title)
      if (!opt) return
      this.showMoreCondition = true
      this.searchForm.regions = [JSON.stringify(opt)]
      this.okBtn()
    },
    gotoDetail (row) {
      this.$router.push({
        name: 'pbrMultilateralDetail',
        query: { key: row.id }
      })
    },
    editFavorite (row) {
      const option = row.favStatus ? 'delete' : 'add'
      this.$pbrApis.editFavorite(option, { id: row.id, type: 5 }).then(res => {
        if (res && res.code === 200) {
          this.search()
        }
      }).catch(() => {})
    },
    exportList () {
      const that = this
      const body = this.getSearchBody()
      const doExport = (selections) => {
        const url = selections
          ? `${this.$pbrApis.exportMultilateralDynamicsExcelUrl}?selections=${encodeURIComponent(selections)}`
          : this.$pbrApis.exportMultilateralDynamicsExcelUrl
        exportFilePost(
          url,
          body,
          `${this.$t('label.export.multilateralList')}`,
          contentType.excel,
          '.xlsx'
        )
      }
      if (!this.tableSelection.length) {
        this.$confirm(that.$t('message.warning.prompt.export'), that.$t('message.warning.prompt.title'), {
          confirmButtonText: that.$t('buttons.ok'),
          cancelButtonText: that.$t('buttons.cancel'),
          type: 'warning'
        }).then(() => {
          doExport('')
        }).catch(() => {
          this.$message({ type: 'info', message: that.$t('message.warning.prompt.exportFailure') })
        })
      } else {
        // selections: id+lang，逗号分隔
        doExport(this.tableSelection.map(t => `${t.id}${t.lang || this.lang}`).join(','))
      }
    },
    openHistory () {
      this.historyModal = true
      this.queryHistorySearch()
    },
    formatHistoryConditionText (cond) {
      if (!cond || typeof cond !== 'object') return ''
      const parts = []
      const kw = cond.searchkey || cond.title || cond.keywords
      if (kw) parts.push(kw)
      const pushCodes = (codes, options, label) => {
        if (!codes) return
        const labels = String(codes).split(/[,，]/).filter(Boolean).map(code => {
          const opt = options.find(o => o.code === code.trim())
          return opt ? this.optionLabel(opt) : code.trim()
        })
        if (labels.length) parts.push(`${label}:${labels.join('、')}`)
      }
      pushCodes(cond.orgCodes, this.orgOptions, this.$t('label.information.multilateral.org'))
      pushCodes(cond.regionCode, this.regionOptions, this.$t('label.information.multilateral.region'))
      pushCodes(cond.tagCode, this.tagOptions, this.$t('label.information.multilateral.infoType'))
      pushCodes(cond.categoryCode, this.categoryOptions, this.$t('label.information.multilateral.infoCategory'))
      if (cond.sourceType) {
        parts.push(`${this.$t('label.source')}:${cond.sourceType}`)
      }
      if (cond.newsTimeStart || cond.newsTimeEnd) {
        const start = cond.newsTimeStart ? String(cond.newsTimeStart).slice(0, 10) : ''
        const end = cond.newsTimeEnd ? String(cond.newsTimeEnd).slice(0, 10) : ''
        parts.push(`${this.$t('label.project.date')}:${start}${start || end ? ' - ' : ''}${end}`)
      }
      return parts.join('，')
    },
    queryHistorySearch () {
      this.$pbrApis.fetchMultilateralSearchHistory({
        lang: this.lang,
        from: this.lang
      }).then(res => {
        if (res && (res.code === 200 || res.success)) {
          const result = res.result
          this.historyTableData = Array.isArray(result) ? result : (result.records || result.list || [])
        }
      }).catch(() => {})
    },
    toTopHistory (row) {
      this.$pbrApis.pinMultilateralSearchHistory({
        id: row.id,
        up: !row.up,
        from: this.lang,
        lang: this.lang
      }).then(res => {
        if (res && (res.code === 200 || res.success)) {
          this.queryHistorySearch()
        }
      }).catch(() => {})
    },
    delHistory (row) {
      this.$pbrApis.deleteMultilateralSearchHistory({
        id: row.id,
        from: this.lang,
        lang: this.lang
      }).then(res => {
        if (res && (res.code === 200 || res.success)) {
          this.queryHistorySearch()
        }
      }).catch(() => {})
    },
    delAllHistory () {
      this.$pbrApis.deleteAllMultilateralSearchHistory({
        lang: this.lang,
        from: this.lang,
        subtype: 'multilateralDynamics',
        type: 'front'
      }).then(() => {
        this.queryHistorySearch()
      }).catch(() => {})
    },
    historyRowDbClick (data) {
      try {
        // 与会展/项目一致：回填字段为 conditions；兼容资讯 searchConditionObj
        let obj = data.conditions || data.searchConditionObj || {}
        if (typeof obj === 'string') {
          obj = JSON.parse(obj)
        }
        this.searchForm.keywords = obj.searchkey || obj.title || obj.keywords || ''
        this.searchForm.searchModel = obj.searchModel != null ? String(obj.searchModel) : '0'
        this.searchForm.pdate = obj.newsTimeStart || obj.newsTimeEnd
          ? [
            obj.newsTimeStart ? String(obj.newsTimeStart).slice(0, 10) : '',
            obj.newsTimeEnd ? String(obj.newsTimeEnd).slice(0, 10) : ''
          ]
          : []
        const fillMulti = (codes, options) => {
          if (!codes) return []
          return String(codes).split(/[,，]/).filter(Boolean).map(code => {
            const opt = options.find(o => o.code === code.trim())
            return JSON.stringify(opt || { code: code.trim(), title: code.trim() })
          })
        }
        this.searchForm.tags = fillMulti(obj.tagCode, this.tagOptions)
        this.searchForm.categories = fillMulti(obj.categoryCode, this.categoryOptions)
        this.searchForm.regions = fillMulti(obj.regionCode, this.regionOptions)
        this.searchForm.orgs = fillMulti(obj.orgCodes, this.orgOptions)
        this.searchForm.sourceType = obj.sourceType || ''
        this.showMoreCondition = true
        this.historyModal = false
        this.okBtn()
      } catch (e) {
        this.historyModal = false
      }
    },
    favIconClass (row) {
      if (row.up) {
        return this.$store.state.brpaModule.theme === 'dark'
          ? { 'fav-icon-dark-active': true }
          : { 'fav-icon-active': true }
      }
      return this.$store.state.brpaModule.theme === 'dark'
        ? { 'fav-icon-dark': true }
        : { 'fav-icon': true }
    },
    syncCondition (field, labelKey, val) {
      if (val && val.length > 0) {
        this.$set(this.myCondition, field, {
          tag: this.$t(labelKey),
          list: val
        })
      } else {
        this.$delete(this.myCondition, field)
      }
    }
  },
  filters: {
    format (value, vue) {
      if (value && value !== '--') {
        return vue.$moment(value).format('yyyy-MM-DD')
      }
      return value
    }
  },
  watch: {
    hotWord: {
      handler (newV) {
        if (newV && newV.trim().length > 0) {
          this.searchForm.keywords = newV
          this.search()
        }
      },
      immediate: true
    },
    regionFilter: {
      handler (val) {
        if (val) {
          this.applyRegionFilter(val)
        }
      },
      deep: true
    },
    'searchForm.orgs' (val) {
      this.syncCondition('orgs', 'label.information.multilateral.org', val)
    },
    'searchForm.regions' (val) {
      this.syncCondition('regions', 'label.information.multilateral.region', val)
    },
    'searchForm.tags' (val) {
      this.syncCondition('tags', 'label.information.multilateral.infoType', val)
    },
    'searchForm.categories' (val) {
      this.syncCondition('categories', 'label.information.multilateral.infoCategory', val)
    },
    'searchForm.sourceType' (val) {
      const text = val && String(val).trim()
      if (text) {
        this.$set(this.myCondition, 'sourceType', {
          tag: this.$t('label.source'),
          text
        })
      } else {
        this.$delete(this.myCondition, 'sourceType')
      }
    },
    'searchForm.pdate' (val) {
      if (val && val.length > 0 && val[0]) {
        this.$set(this.myCondition, 'pdate', {
          tag: this.$t('label.theDateRange'),
          list: val
        })
      } else {
        this.$delete(this.myCondition, 'pdate')
      }
    }
  }
}
</script>

<style scoped>
.condition-container {
  position: relative;
  overflow: hidden;
  transition: all 0.2s linear;
}
.pbr-info-history-table >>> .ivu-table td {
  cursor: pointer;
}
.ivu-switch-inner-en {
  left: -3px;
  position: absolute;
}
.md-info-tag {
  margin-right: 4px;
  cursor: pointer;
  color: rgb(45, 140, 240);
}
</style>
